import React, { memo } from 'react';

import chatBackground from '../../../assets/img/chat-background.png';

type Props = {
  styles?: React.CSSProperties;
};

const CommunityChatbackgroundLayer: React.FC<Props> = ({ styles }) => {
  return (
    <div
      style={{
        backgroundImage: `url(${chatBackground})`,
        position: 'absolute',
        height: 'inherit',
        width: '100%',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        zIndex: -1,
        opacity: 1,
        filter: 'contrast(25%)',
        backgroundColor: '#fff7eff2',
        top: 0,
        backgroundBlendMode: 'soft-light',
        ...styles,
      }}
    />
  );
};

export default memo(CommunityChatbackgroundLayer);
